import { Effect, Layer } from 'effect'

export const appMemoMap = Effect.runSync(Layer.makeMemoMap)
